import { Grid, Box, Typography } from '@mui/material';
import { t } from 'i18next';

interface ColorLabel {
  color: string;
  label: string;
}

interface LegendRow {
  colorLabels: ColorLabel[];
}

function BakeasyLegendRow(props: LegendRow) {
  return (
    <Grid container sx={{ mt: 2, mb: -1, alignItems: 'center' }}>
      {props?.colorLabels?.map((item, index) => (
        <Grid item key={index} sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
          <Box
            sx={{ width: 20, height: 20, backgroundColor: item.color, mr: 1, borderRadius: 1 }}
          />
          <Typography sx={{ fontSize: '0.8rem' }}>{t(item.label)}</Typography>
        </Grid>
      ))}
    </Grid>
  );
}

export default BakeasyLegendRow;
